import { useMediaQuery, useTheme } from '@material-ui/core';
import React, { CSSProperties, FC } from 'react'

interface IPageDividerProps {
  styles:React.CSSProperties;
  onDeviceStyles?: {
    mobile?: CSSProperties,
    desktop?: CSSProperties,
  }
}

export const PageDivider:FC<IPageDividerProps> = ({styles,onDeviceStyles}) => {
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down('sm'));
  const mergeStyles =  isMobileDevice ? onDeviceStyles?.mobile : onDeviceStyles?.desktop;
  return (
    <div style={{...styles,...mergeStyles}}></div>
  )
}
